const genRoute = ({ basePath, source }) => ({
  list: () => `/${basePath}/${source}`,
  edit: (id) => `/${basePath}/${source}/${id}`,
  create: () => `/${basePath}/${source}/new`,
});

const initBaseRouting = ({ basePath, sourcesList }) => {
  const router = {};
  sourcesList.forEach((source) => {
    if (source == 'contributions') {
      router[source] = {
        list: () => `/${basePath}/${source}`,
        athleteList: (trainerId) =>
          `/${basePath}/${source}/trainers/${trainerId}`,
      };
    } else if (source == 'certifications') {
      router[source] = {
        list: () => `/${basePath}/${source}`,
        create: () => `/${basePath}/${source}/new`,
        edit: (id) => `/${basePath}/${source}/${id}`,
        athleteList: (certificationId) =>
          `/${basePath}/${source}/${certificationId}/athletes`,
        addAthlete: (certificationId) =>
          `/${basePath}/${source}/${certificationId}/add-athlete`,
        editAthlete: (certificationId, certificationAthleteId) =>
          `/${basePath}/${source}/${certificationId}/edit-athlete/${certificationAthleteId}`,
        Statement: (certificationId) =>
          `/${basePath}/${source}/${certificationId}/statement`,
        Protocol: (certificationId) =>
          `/${basePath}/${source}/${certificationId}/protocol`,
        Statistics: (certificationId) =>
          `/${basePath}/${source}/${certificationId}/statistics`,
        ListAthlete: (certificationId, trainerId) =>
          `/${basePath}/${source}/${certificationId}/${trainerId}/listathlete`,
        ListAthleteProt: (certificationId, rank, protocolId) =>
          `/${basePath}/${source}/${certificationId}/${rank}/${protocolId}/listathleteprotocols`,
      };
    } else {
      router[source] = genRoute({ basePath, source });
    }
  });
  return router;
};

const sources = [
  'managers',
  'permissions',
  'superManagers',
  'trainers',
  'athletes',
  'clubs',
  'gyms',
  'groups',
  'contributions',
  'certifications',
  'certifications_athlete',
];

const router = {
  cabinet: initBaseRouting({ basePath: 'cabinet', sourcesList: sources }),
  admin: initBaseRouting({ basePath: 'admin', sourcesList: sources }),
};

export default router;
